import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

const useNoticesStore = defineStore('notices', () => {
  const unreadCount = ref<number>(0);

  function updateUnreadCount(v: number) {
    unreadCount.value = v;
  }

  return {
    unreadCount: computed(() => unreadCount.value),
    updateUnreadCount,
  };
});

export default useNoticesStore;
